import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prependProtocol',
    standalone: true
})
export class PrependProtocolPipe implements PipeTransform {

  transform(link: string): string {
    return (!link || !link.trim().length || link.startsWith('http')) ?
        link : 'http://' + link;
  }

}
